import React, { FC, useState } from 'react'
import { SmartVisibleChild, useToggleAccordionHandler } from '@mtsdengi/common'
import { TFaq } from '../../types'
import { Styled } from './styled'

export const FaqDesktop: FC<TFaq> = ({ sections, onChangeCategory, onCollapseQuestion, onExpandQuestion }) => {
  const [activeSection, setActiveSection] = useState(0)

  const { toggleAbleItems, toggleAccordionHandler } = useToggleAccordionHandler({
    items: sections[activeSection].questions,
    onOpen: onExpandQuestion,
    onClose: onCollapseQuestion,
  })

  return (
    <SmartVisibleChild
      conditions={{
        mob: 'none',
        md: 'block',
      }}
    >
      <Styled.Wrapper>
        <Styled.Sections>
          {sections.map(({ title }, index) => (
            <Styled.SectionButton
              key={title}
              onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                setActiveSection(index)
                onChangeCategory?.(e)
              }}
              isActive={index === activeSection}
            >
              {title}
            </Styled.SectionButton>
          ))}
        </Styled.Sections>
        <Styled.AccordionWrapper>
          <Styled.DesktopAccordion
            extraLayer
            domMounted
            items={toggleAbleItems}
            variant="violet"
            onToggle={toggleAccordionHandler}
          />
        </Styled.AccordionWrapper>
      </Styled.Wrapper>
    </SmartVisibleChild>
  )
}
